import { render, staticRenderFns } from "./setting-form.vue?vue&type=template&id=ab520c9c&"
import script from "./setting-form.vue?vue&type=script&lang=js&"
export * from "./setting-form.vue?vue&type=script&lang=js&"
import style0 from "./setting-form.vue?vue&type=style&index=0&id=ab520c9c&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports